export const esignatureErrandCommand = {
  openESignatureDocument: 'openESignatureDocument',
  cancelESignatureErrand: 'cancelESignatureErrand',
};
